var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.19231,2.14423V5.31731h-1.887A1.76624,1.76624,0,0,0,13.91106,5.75a1.99087,1.99087,0,0,0-.36058,1.29808V9.31971h3.52164l-.46876,3.55769H13.55048V22H9.8726V12.8774H6.80769V9.31971H9.8726V6.69952a4.64923,4.64923,0,0,1,1.25-3.46755A4.53664,4.53664,0,0,1,14.45192,2a19.88387,19.88387,0,0,1,2.74039.14423Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.48d5319e57c57daca71a619bb3dfbd7a.svg";
export { ForwardRef as ReactComponent };